export enum PRICE_CONVERSION {
    PESOS_TO_USD = 0.05,
    USD_TO_PESOS = 1 / 0.05,

    PESOS_TO_EUR = 0.053,
    EUR_TO_PESOS = 1 / 0.053,

    PESOS_TO_CAD = 0.078,
    CAD_TO_PESOS = 1 / 0.078,

    USD_TO_EUR = 0.93,
    EUR_TO_USD = 1 / 0.93,

    USD_TO_CAD = 1.36,
    CAD_TO_USD = 1 / 1.36,

    EUR_TO_CAD = 1.48,
    CAD_TO_EUR = 1 / 1.48,
    // USD_TO_PESOS = Number(currenciesStore.currencies.usd.usdToPesos),
    // USD_TO_CAD = Number(currenciesStore.currencies.usd.usdToCad),
    // USD_TO_EUR = Number(currenciesStore.currencies.usd.usdToEur),
    //
    // PESOS_TO_USD = Number(currenciesStore.currencies.mxn.pesosToUsd),
    // PESOS_TO_EUR = Number(currenciesStore.currencies.mxn.pesosToEur),
    // PESOS_TO_CAD = Number(currenciesStore.currencies.mxn.pesosToCad),
    //
    // EUR_TO_PESOS = Number(currenciesStore.currencies.fr.eurToPesos),
    // EUR_TO_CAD = Number(currenciesStore.currencies.fr.eurToCad),
    // EUR_TO_USD = Number(currenciesStore.currencies.fr.eurToUsd),
    //
    // CAD_TO_USD = Number(currenciesStore.currencies.cad.cadToUsd),
    // CAD_TO_PESOS = Number(currenciesStore.currencies.cad.cadToPesos),
    // CAD_TO_EUR = Number(currenciesStore.currencies.cad.cadToEur),
}

export enum RATIO_LABEL {
    EUR_TO_PESOS = "euroToPesos",
    EUR_TO_USD = "euroToUsd",
    EUR_TO_CAD = "euroToCad",

    USD_TO_PESOS = "usdToPesos",
    USD_TO_EUR = "usdToEuro",
    USD_TO_CAD = "usdToCad",

    CAD_TO_PESOS = "cadToPesos",
    CAD_TO_EUR = "cadToEuro",
    CAD_TO_USD = "cadToUsd",

    PESOS_TO_USD = "pesosToUsd",
    PESOS_TO_EUR = "pesosToEuro",
    PESOS_TO_CAD = "pesosToCad",
}

export enum CURRENCY_OPTIONS {
    USD = "USD",
    MXN = "MXN",
    CAD = "CAD",
    EUR = "EUR",
}
